import styled from 'styled-components';
import {dFlex, dFlexColumn, dFlexCenter, alignCenter} from '../../../../globalVariables/GlobalFlex';

export const list = styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    ${dFlexColumn}
`;

export const row = styled.a`
    ${dFlex}
    ${alignCenter}
    gap: var(--space-md);
    height: 64px;
    padding-inline: var(--space-xl);
    color: var(--color-text-default);
    text-decoration: none;
    border-bottom: 1px solid var(--color-border-subtle);

    &:last-child {
        border-bottom: none;
    }
`;

export const rowIcon = styled.span`
    flex: none;
    width: 24px;
    height: 24px;
    ${dFlexCenter};
    color: var(--color-text-default);
`;

export const rowLabel = styled.span`
    flex: 1;
    min-width: 0;
    font-size: var(--font-size-body);
`;

export const rowValue = styled.span`
    color: var(--color-text-subtle);
    font-size: var(--font-size-body-small);
`;
